// src/pages/NoNetwork.tsx
import { useNetwork } from "@/hooks/useNetwork";
import { FiWifiOff, FiRefreshCw } from "react-icons/fi";
import { motion } from "framer-motion";

const NoNetwork = () => {
  const { isLoading, checkNetwork } = useNetwork();

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-50 text-center p-4" dir="rtl">
      {/* Icon with animation */}
      <motion.div
        animate={{ 
          scale: [1, 1.1, 1],
          rotate: [0, 5, -5, 0]
        }}
        transition={{ repeat: Infinity, duration: 2 }}
        className="mb-6 text-red-500"
      >
        <FiWifiOff className="text-6xl" />
      </motion.div>

      {/* Heading */}
      <h1 className="text-4xl sm:text-5xl font-bold text-gray-800 mb-4">
        لا يوجد اتصال بالإنترنت
      </h1>

      {/* Description */}
      <p className="text-lg sm:text-xl text-gray-600 mb-8">
        أنت غير متصل بالإنترنت حالياً. يرجى التحقق من اتصال الشبكة.
      </p>

      {/* Button with loading state */}
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={checkNetwork}
        disabled={isLoading}
        className={`px-6 py-3 rounded-lg transition-all flex items-center gap-2 ${
          isLoading
            ? "bg-gray-300 text-gray-500"
            : "bg-sidebar text-skyblue"
        }`}
      >
        {isLoading ? (
          <>
            <motion.span
              animate={{ rotate: 360 }}
              transition={{ repeat: Infinity, duration: 1 }}
            >
              <FiRefreshCw />
            </motion.span>
            جاري التحقق من الاتصال...
          </>
        ) : (
          <>
            <FiRefreshCw />
            إعادة المحاولة
          </>
        )}
      </motion.button>

      {/* Additional content */}      
    </div>
  );
};

export default NoNetwork;